import { useState } from 'react'
import {
  deleteACHExceptionRuleList,
  getACHClientList,
  getACHExceptionRuleList,
} from '../../../../shared/services/ACHExceptionRuleService'
import { ICommonObject } from 'src/app/shared/models/common.model'
import { getClientListName } from 'src/app/shared/services/ClientSetupService'

interface Export {
  chosenColumnNameList: string[]
  pageName: string
  header: string
}

export interface IReqACHExceptionRulesPayload {
  searchTerm?: string
  searchColumns?: Array<string>
  isDesc?: boolean
  sortColumns?: Array<string>
  sortColumnsDictionary?: ICommonObject
  pageSize?: number
  pageIndex?: number
  filterOption?: number
  export?: Export
  filterId?: string
}

interface IACHExceptionRule {
  ruleId: string
  description: string
  ruleType: string
  achOriginatorID: string
  secCode: string[]
  creditDebit: string
  amountFrom: number
  amountTo: number
  clientNames: string
  systemRule: boolean
}

export const useACHExceptionRule = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [ACHExceptionRuleList, setACHExceptionRuleList] = useState<Array<IACHExceptionRule>>([])
  const [totalRecords, setTotalRecords] = useState(0)

  const formatData = (data: any) => {
    return data?.map((item: any) => {
      return {
        ...item,
      }
    })
  }

  const getACHExceptionRuleListData = async (params: IReqACHExceptionRulesPayload) => {
    try {
      setIsLoading(true)
      const data = await getACHExceptionRuleList(params)
      setACHExceptionRuleList(formatData(data?.data?.items))
      setTotalRecords(data?.data?.total)
      return data?.data
    } catch (e) {
      console.log('ERROR: ', e)
    } finally {
      setIsLoading(false)
    }
  }

  return { ACHExceptionRuleList, totalRecords, getACHExceptionRuleListData, isLoading }
}

export const useClientSelectData = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [clientOptions, setClientOptions] = useState<Array<{ label: string; value: string }>>([])
  const [totalRecords, setTotalRecords] = useState(0)

  const formatResData = (data: any): { label: string; value: string }[] => {
    if (data) {
      return data?.map((item: any) => ({
        label: item.clientName,
        value: item.id,
      }))
    }

    return []
  }

  const getClientOptions = async () => {
    try {
      setIsLoading(true)
      const data = await getClientListName()
      setClientOptions(formatResData(data?.data))
      // setTotalRecords(data?.data?.total)

      return data?.data
    } catch (e) {
      console.log('ERROR: ', e)
    } finally {
      setIsLoading(false)
    }
  }

  return { clientOptions, totalRecords, getClientOptions, isLoading }
}

export const useDeleteACHException = () => {
  const [isLoading, setIsLoading] = useState(false)

  const deleteACHException = async (id: string) => {
    try {
      setIsLoading(true)

      const data = await deleteACHExceptionRuleList(id)

      return data?.data
    } catch (e) {
      console.log('ERROR: ', e)
    } finally {
      setIsLoading(false)
    }
  }

  return { isLoading, deleteACHException }
}
